export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20abstract%20artistic%20background%20with%20warm%20coral%20and%20cream%20gradients%2C%20subtle%20geometric%20patterns%2C%20clean%20minimalist%20aesthetic%2C%20Japanese%20and%20Korean%20ink%20wash%20painting%20inspired%20texture%2C%20gentle%20flowing%20shapes%2C%20editorial%20design%20background%2C%20high%20resolution%2C%20soft%20lighting&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫之家背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/85 via-background-50/70 to-background-50/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5 tracking-wide">
              韩漫下载 · 离线阅读 · APK安装
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              韩漫之家 — 你的韩漫下载安装与离线免费阅读首选
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-semibold mb-5 leading-relaxed">
              随时随地，离线畅享韩漫全集
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              韩漫之家专注为韩漫爱好者提供一站式的韩漫下载安装与离线阅读服务。平台汇聚最全韩漫资源，覆盖热门连载、经典完结与独家汉化内容，
              支持韩漫APK轻松获取与一键安装，让用户无需网络也能随时随地畅享高质量韩漫。当前正持续跟进最新热门韩漫更新，
              确保读者第一时间追更。无论你是新入坑还是老读者，韩漫之家都是你离线看韩漫的不二之选。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">韩漫资源覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步最新连载</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">全离线</div>
                <div className="text-xs text-foreground-500 mt-1">无需网络畅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-download-line text-lg"></i>
                获取韩漫APK
              </a>
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-300 text-primary-700 font-semibold rounded-full text-sm hover:bg-primary-50 transition-colors duration-200"
              >
                <i className="ri-book-open-line text-lg"></i>
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/5] max-w-[380px] mx-auto rounded-2xl overflow-hidden bg-background-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20Korean%20webtoon%20style%20illustration%20of%20a%20smartphone%20screen%20displaying%20beautiful%20manga%20style%20comic%20panels%20with%20vibrant%20characters%2C%20warm%20lighting%2C%20modern%20UI%20design%2C%20clean%20composition%2C%20editorial%20illustration%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20high%20quality%20artwork&width=800&height=1000&seq=hero-main-2026&orientation=portrait"
                alt="韩漫之家 - 手机离线阅读韩漫"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}